import type { ISchema } from '../../@types'
import { IdentsOverrideId } from '@/helpers/identsOverrideIds'

// +20% premium products (intro + renewal) for female (used when High CR + High WTP).
// Source: DEV-33300.
import simple_premium_1w_6_19_4w_52_usd from '@/data/products/subscription/prd_xbD2yvDTb9Zf'
import simple_premium_1w_4_99_4w_52_usd from '@/data/products/subscription/prd_lFznPiNLXdRO'
import simple_premium_4w_11_99_4w_52_usd from '@/data/products/subscription/prd_f0W2DVjINO3H'
import simple_premium_4w_9_59_4w_52_usd from '@/data/products/subscription/prd_sgo5bMYlgkdh'
import simple_premium_12w_23_99_12w_99_usd from '@/data/products/subscription/prd_LWVf3nlME2pf'
import simple_premium_12w_19_19_12w_99_usd from '@/data/products/subscription/prd_PewFy4aQqF51'

// Female base (f.ts) has: original=null, discounted=base, fallback=fallback + ML_PRICE_DISCOUNT override.
// This transformer adds ML_PRICE_PREMIUM (+20% intro + renewal) on top, preserving the rolled-out discount.
export default (schema: ISchema): ISchema => {
	const products = schema.config?.products
	if (!products) return schema

	const premiumOverrides = [
		{
			id: IdentsOverrideId.ML_PRICE_PREMIUM,
			original: null,
			discounted: simple_premium_1w_6_19_4w_52_usd.ident,
			fallback: simple_premium_1w_4_99_4w_52_usd.ident,
		},
		{
			id: IdentsOverrideId.ML_PRICE_PREMIUM,
			original: null,
			discounted: simple_premium_4w_11_99_4w_52_usd.ident,
			fallback: simple_premium_4w_9_59_4w_52_usd.ident,
		},
		{
			id: IdentsOverrideId.ML_PRICE_PREMIUM,
			original: null,
			discounted: simple_premium_12w_23_99_12w_99_usd.ident,
			fallback: simple_premium_12w_19_19_12w_99_usd.ident,
		},
	]

	const updatedProducts = products.map((product, index) => ({
		...product,
		identsOverride: [...(product.identsOverride || []), premiumOverrides[index]],
	}))

	return { ...schema, config: { ...schema.config, products: updatedProducts } }
}
